import { useSelector } from 'react-redux'
import { savedFormState } from './selectors'

export const useSavedFormState = (app, model) =>
  useSelector(savedFormState(app, model))

export const useHasPendingForms = () =>
  useSelector((state) => !!Object.keys(state.formState).length)
